/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {AsyncTaskStatus} from '@ion/core/src/types/entities';
import {ColoredStatusCell} from '@ion/dls/src/grid/ColoredStatusCell';

export type StatusCellProps = {
  value?: AsyncTaskStatus;
  isPadding?: boolean;
};

/**
 * Cell Renderer for rendering colored badges based on the given status.
 */
export const JobStatusCellRenderer = memo(({value: status, isPadding = false}: StatusCellProps) => {
  return status ? <ColoredStatusCell isPadding={isPadding} status={translate(`common:jobStatus.${status}`).toUpperCase()} /> : <div/>;
});

export default JobStatusCellRenderer;
